export var ClientPlatform;
(function (ClientPlatform) {
    ClientPlatform["Android"] = "android";
    ClientPlatform["CommercialWeb"] = "commercial_web";
    ClientPlatform["Desktop"] = "desktop";
    ClientPlatform["iOS"] = "ios";
    ClientPlatform["Web"] = "web";
})(ClientPlatform || (ClientPlatform = {}));
export var CDFEventGroup;
(function (CDFEventGroup) {
    CDFEventGroup["Analytics"] = "analytics";
})(CDFEventGroup || (CDFEventGroup = {}));
